export default "__VITE_ASSET__DiNh8vBj__"